import { useState } from "react";
import ExtraPayService from "../../../../../service/ExtraPayService";
import useApiStatus from "../../../../../hooks/useApiStatus";

const useConvertWalletValue = ({
  conversion,
  onError,
  onErrorConversionIsZero,
  onSuccess,
  onErrorExpiredConversion,
}) => {
  const [conversionAmount, setConversionAmount] = useState("");
  const { isLoading, setIsLoading } = useApiStatus({
    isLoading: false,
  });
  const service = new ExtraPayService(localStorage.getItem("__extraconomy_token"));

  const convertToWallet = async () => {
    setIsLoading(true);
    try {
      if (conversionAmount === 0) {
        onErrorConversionIsZero();
        setIsLoading(false);
        return;
      }
      await service
        .convertUserWalletValue({
          idconversion: conversion.id,
          amountToConvert: conversionAmount,
          user: {
            username: localStorage.getItem("__extraconomy_username"),
          },
        })
        .then((response) => {
          if (response.messageCode === 500152) {
            setIsLoading(false);
            onErrorExpiredConversion();
            return;
          } else if (response.messageCode !== 200000) {
            setIsLoading(false);
            onError(response.messageCode);
            return;
          }
          setIsLoading(false);
          onSuccess();
        });
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      onError(error);
    }
  };

  return {
    conversionAmount,
    setConversionAmount,
    convertToWallet,
    isLoading,
  };
};

export default useConvertWalletValue;
